export default __webpack_public_path__ + "static/media/retrotv.df293b24.png";